angular.module('cfn').controller('calendarController', calendarController);

calendarController.$inject = [
  '$scope',
  '$rootScope',
  '$http',
  '$dialog',
  '$timeout',
  'calendarService',
  'escapeHtmlFilter',
  'journalMarkupFilter'
];
function calendarController(
  $scope,
  $rootScope,
  $http,
  $dialog,
  $timeout,
  calendarService,
  escapeHtmlFilter,
  journalMarkupFilter
) {
  'use strict';

  $scope.entry = {};
  $scope.persons = [];

  /**
   * Den neuen Eintrag abschicken und bei Erfolg hinzufügen des Eintrags zum Kalender
   */
  $scope.addEntry = function() {
    var entry = $.extend(true, {}, $scope.entry);
    // delete entry.id;
    entry.title = entry.subject;
    entry.persons = $scope.persons;

    // convert timestamp to ISO
    entry.startDate = new Date(entry.startDate);
    entry.endDate = new Date(entry.endDate);
    if (entry.allDay) {
      entry.startDate.setHours(0, 0, 0, 0);
      entry.endDate = entry.startDate;
    }

    $http.post('/365FarmNet/rest/calendar/addEntry', entry).then(function() {
      //better reset the filter, we might have added an entry from an until now unknown category.
      $scope.getFilterSettings = calendarService
        .getFilter()
        .then(function(filter) {
          $scope.filter = filter;
          $scope.updateCalendar();
        });
    });
  };

  /**
   * Deletes a calendar task from database and view if successful
   */
  $scope.deleteCalendarTask = function(eventId) {
    $scope.deleteEntry(eventId);
  };

  $scope.deleteEntry = function(eventId) {
    if (eventId) {
      // console.log('before');
      $http
        .delete('/365FarmNet/rest/calendar/' + eventId)
        .then(function(response) {
          // console.log('success');
          if (response.data.success) {
            // Wenn das Löschen erfolgreich war, das Event dem Kalender entfernen.
            $('.fullCalendar').fullCalendar('removeEvents', eventId);
            $('*').qtip('hide');
          }
        });
    }
    // console.log('after');
  };

  // private helper function
  var editCalendarTask = function(eventId) {
    $scope.$apply(function() {
      $scope.editEntry(eventId);
    });
  };

  $scope.editEntry = function(eventId) {
    if (eventId) {
      // console.log('edt before');
      $http
        .get('/365FarmNet/rest/calendar/single/' + eventId)
        .then(function(response) {
          var data = response.data;
          if (data) {
            // console.log('edt success');
            // Wenn das Speichern erfolgreich war, das Event dem Kalender hinzufügen.
            $scope.entry.id = data.entry.id;
            $scope.entry.private_ = data.entry.private_;
            $scope.entry.title = data.entry.subject;
            $scope.entry.subject = data.entry.subject;
            $scope.entry.description = data.entry.description;
            $scope.entry.startDate = new Date(data.entry.startDate).getTime();
            $scope.entry.endDate = new Date(data.entry.endDate).getTime();
            $scope.entry.doRemind = data.entry.doRemind;
            $scope.entry.reminderTyp_EMAIL = data.entry.reminderTyp_EMAIL;
            $scope.entry.reminderTyp_SMS = data.entry.reminderTyp_SMS;
            $scope.entry.reminderUnit = data.entry.reminderBeforeUnit;
            $scope.entry.reminderBefore = data.entry.reminderBefore;
            $scope.entry.combinedName = data.combinedName;
            $scope.entry.location = data.entry.location;
            $scope.entry.personId = data.person.id;
            $scope.entry.personCombinedName = data.person.combinedName;
            $scope.entry.person = data.person;
            $scope.allDay = data.entry.allDay;
            $scope.entry.allDay = data.entry.allDay;
            $scope.entry.persons = JSON.parse(data.entry.notesJson);
            $scope.isValid = true;
            $('*').qtip('hide');
            $scope.showCalendarTaskDialog();
          }
        });
      // console.log('edt after');
    }
  };

  $scope.showCalendarTaskDialog = function() {
    if (!$scope.entry.id) {
      $scope.persons = [$scope.credentials.person];
    } else {
      $scope.persons = $scope.entry.persons;
    }
    $dialog
      .dialog({
        resolve: {
          entry: function() {
            return $scope.entry;
          },
          persons: function() {
            return $scope.persons;
          }
        }
      })
      .open(require('./calendarPopup.html'), 'calendarPopupController')
      .then(function(exitResult) {
        if (exitResult) {
          if (exitResult.result == 'ok') {
            console.debug('adding entry');
            $scope.entry = exitResult.entry;
            $scope.persons = exitResult.persons;
            $scope.addEntry();
          } else if (exitResult.result == 'delete') {
            console.debug('deleting entry');
            $scope.deleteCalendarTask(exitResult.eventId);
          } else {
            console.debug('hmm', exitResult);
          }
        }
      });
  };

  $scope.updateCalendar = function() {
    // Tell the calendar widget that it should reload events
    var qCalender = $('#calendar');
    qCalender.fullCalendar('refetchEvents');
  };

  $scope.initCalendar = function() {
    $timeout(function() {
      // preserve current calendar view
      var currentCalenderViewName =
        getCookie('currentCalenderViewName') || 'agendaWeek';

      $('.fullCalendar').fullCalendar({
        // Assign fetch function
        events: function(start, end, timezone, callback) {
          if ($scope.filter !== undefined) {
            calendarService
              .fetchFullCalendarEvents(start, end, $scope.filter, timezone)
              .then(callback);
          }
        },
        defaultView: currentCalenderViewName,
        header: {
          left: 'prev,next',
          center: 'title',
          right: 'month,agendaWeek'
        },
        editable: false,
        firstDay: 1,
        firstHour: 8,
        slotMinutes: 30,
        snapMinutes: 60,
        height: 'auto',
        // defaultEventMinutes: 120,
        lang: calendarService.getFullCalendarLang(),
        // Work with user's client timezone
        timezone: 'local',
        selectable: true,
        selectHelper: true,
        select: function(start, end, jsEvent, view) {
          var allDay = !start.hasTime() && !end.hasTime();

          if (!app.hasRight('CalendarTask:CREATE')) {
            $rootScope.alertController.addTemporaryAlert(
              i18n(
                'fe.common.rightsPopup.basic.message',
                'Um diesen Dienst zu nutzen, benötigen Sie zusätzliche Rechte. Bitte kontaktieren Sie Ihren Konto-Administrator'
              ),
              'error'
            );
            return;
          }
          $scope.entry = {
            doRemind: false,
            private_: false,
            allDay: allDay,
            subject: '',
            location: '',
            description: '',
            reminderTyp_EMAIL: false,
            reminderTyp_SMS: false,
            reminderBefore: 15,
            reminderUnit: 'TIME_MIN',
            startDate: start,
            endDate: end
          };
          $scope.showCalendarTaskDialog();
          $scope.$apply();
          $timeout(function() {
            $('#entrySubject')
              .focus()
              .select();
          }, 300);
        },
        //http://arshaw.com/fullcalendar/docs/display/viewRender/
        viewRender: function(view) {
          ang.apply($scope, function() {
            $scope.isWeekView = view.name === 'agendaWeek';
          });
        },
        eventRender: function(event, element) {
          if (!event.weatherInfo) {
            element.addClass('allday');
            element
              .parent()
              .next()
              .css('height', 'auto');
            element.css('background-color', event.backgroundColor);
            element.css('border-color', event.backgroundColor);
            if (event.operationId) {
              var eventDescription = '';
              if (event.description) {
                eventDescription = escapeHtmlFilter(event.description);
                eventDescription = journalMarkupFilter(eventDescription);
              }
              eventDescription += '';
              eventDescription =
                '<div>' +
                eventDescription +
                '</div>' +
                "<div style='text-align: right;padding-top: 15px;'>" +
                '<button class=\'btn\' style=\'margin-right:4px;\' onclick=\'$(".qtip").qtip("hide");location.href="#/booking/field/' +
                event.operationId +
                "\"' hasright='Company:BOOKING'>" +
                i18n('fe.journals.toDocumentation', 'zur Dokumentation') +
                '</button></div>';

              // Planning calender event: when clicked show the small popup with detail journal
              // description
              element.qtip({
                content: {
                  // text: event.description + "</p><input type=\"button\" name=\"Löschen\"
                  // onclick=\"deleteEntry(" + event._id + ")\"></input>",
                  text: eventDescription,
                  title: {
                    text: event.title,
                    button: true
                  }
                },
                position: {
                  at: 'bottom center', // Position the tooltip above the link
                  my: 'top center',
                  viewport: $(window), // Keep the tooltip on-screen at all times
                  effect: false // Disable positioning animation
                },
                show: {
                  event: 'click',
                  solo: true // Only show one tooltip at a time
                },
                hide: 'unfocus',
                style: {
                  classes: 'qtip-wiki qtip-light qtip-shadow'
                }
              });
            } else {
              if (app.hasRight('CalendarTask:UPDATE')) {
                // Normal calendar event: when clicked show its details popup immediately
                element.click(function() {
                  editCalendarTask(event.id);
                });
              }
            }
          } else {
            $(element).remove();
          }
        }
      });

      // preserve current calendar view
      $('.fc-button').click(function() {
        var view = $('.fullCalendar').fullCalendar('getView');

        setCookie('currentCalenderViewName', view.name);
        //console.log("currentCalenderViewName= " + getCookie("currentCalenderViewName"));
      });
    });
  };

  $scope.toDocumentation = function(target) {
    console.log('faceme: ' + target);
  };

  $scope.isWeekView = function() {
    return $('.fullCalendar').fullCalendar('getView').name === 'agendaWeek';
  };

  $scope.getVisualDay = function(offset) {
    // http://stackoverflow.com/questions/563406/add-days-to-datetime
    var date = $('.fullCalendar').fullCalendar('getView').visStart;
    if (!date) return undefined;
    var result = new Date(date);
    result.setDate(date.getDate() + offset || 0);
    return result.getTime();
  };

  $scope.filter = undefined;
  $scope.getFilterSettings = calendarService.getFilter().then(function(filter) {
    $scope.filter = filter;
    $scope.updateCalendar();
  });

  $scope.doFilterExists = function(tmpFilter, filterName) {
    var filterExists = false;
    $.each(tmpFilter, function(i, xTmpFilter) {
      if (xTmpFilter.name === filterName) {
        filterExists = true;
      }
    });
    return filterExists;
  };

  /**
   * show popup with filter options for the calendar
   */
  $scope.showFilter = function() {
    $dialog
      .dialog({
        dialogClass: 'modal',
        resolve: {
          calendarController: function() {
            return $scope;
          }
        }
      })
      .open(
        require('./calendarFilterPopup.html'),
        'calendarFilterPopupController'
      );
  };

  $scope.initCalendar();
  $scope.calendarController = this;

  return this;
}
